<template>
    <v-container class="max-container">
        <v-row class="flex-row-center">
            <div>
                <v-img class="div__emptyimg" src="@/assets/empty-views/empty_indicate.svg" />
            </div>                      
        </v-row>        
    </v-container>
</template>

<script>
export default {
    name: 'referFriends'
}
</script>

<style scoped>
.div__emptyimg {    
    width: 320px;
}
</style>